/* tslint:disable */

declare var Object: any;
export interface SFRequestInboxInterface {
  "id"?: number;
}

export class SFRequestInbox implements SFRequestInboxInterface {
  "id": number;
  constructor(data?: SFRequestInboxInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFRequestInbox`.
   */
  public static getModelName() {
    return "SFRequestInbox";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFRequestInbox for dynamic purposes.
  **/
  public static factory(data: SFRequestInboxInterface): SFRequestInbox{
    return new SFRequestInbox(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFRequestInbox',
      plural: 'SFRequestInboxes',
      path: 'SFRequestInboxes',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFRequestInbox.ts